module.exports = __webpack_public_path__ + "img/smile-great.e20ed6b2.svg";